/*
 * Where: src/features/howtouse/components/HowToUseStepsSection.js
 * What: Step list for how-to-use instructions.
 * Why: Separate procedure rendering from page template.
 */
import React from 'react';

function HowToUseStepsSection({ steps }) {
    return (
        <section className="section-block">
            <h2>操作手順</h2>
            <div className="step-grid">
                {steps.map((step) => (
                    <article className="step-card" key={step.id}>
                        <p className="step-id">STEP {step.id}</p>
                        <h3>{step.title}</h3>
                        <p>{step.detail}</p>
                    </article>
                ))}
            </div>
        </section>
    );
}

export default HowToUseStepsSection;
